const preScanES = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Resultados de Pre-Scan",
                "body": {
                    "description": "Los siguientes resultados han sido encontrados después de realizar el escaneo para esta publicación. Por favor, compruebe estos en detalle:",
                    "table": {
                        "column": {
                            "trackName": "Nombre de la Pista",
                            "type": "Tipo",
                            "title": "Título",
                            "artists": "Artistas",
                            "album": "Álbum",
                            "label": "Sello",
                            "releaseDate": "Fecha de Lanzamiento",
                            "score": "Puntuación (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Pistas Marcadas",
                        "music": "Música",
                        "cover": "Capa",
                        "signDeclaration": "Por favor, firme la declaración para continuar.",
                        "cancelRelease": "Quiero cancelar esta publicación.",
                        "approveRelease": {
                            "point1": "Quiero aprobar esta publicación porque los resultados mostrados son 100% idénticos a mi propia publicación / transferiéndose desde el distribuidor anterior.",
                            "point2": "Por la presente, declaro solemnemente, bajo pena de perjurio, que todo contenido que proporciono es propiedad de mi empresa o de mí, o que poseo derechos y licencias completos y válidos necesarios para su uso, distribución y presentación.",
                            "point3": "Reconozco y acepto que soy completamente responsable de cualquier consecuencia legal que surja de la presentación de tal contenido, incluyendo pero no limitado a procesos legales, reclamaciones, costos y gastos.",
                            "point4": "Entiendo y acepto que mis datos personales, incluyendo información KYC y cualquier otra información relevante, pueden ser compartidos con socios autorizados, proveedores de servicios digitales (DSPs), terceros involucrados en el procesamiento de tal contenido, así como tribunales, autoridades reguladoras y agencias de aplicación de la ley en caso de cualquier reclamo, disputa o requerimiento legal.",
                            "point5": "Entiendo y acepto que Music Link tiene el derecho de inmediatamente terminar mi acuerdo, sin ningún pago o obligación adicional, si se demuestra que he utilizado este formulario de manera incorrecta o si alguna parte de mi declaración es falsa, engañosa o mal representada.",
                        },
                        "noFlaggedTracks": "No se han detectado pistas marcadas en el pre-escaneo, puedes continuar con los siguientes pasos!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Enviar",
                    "close": "Cerrar"
                }
            },
            "performScan": {
                "header": "Realizar Pre-Escaneo",
                "body": "Por favor, confirma que quieres realizar el pre-escaneo para esta publicación.",
                "button": {
                    "cancel": "Cancelar",
                    "performScan": "Realizar Escaneo"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Has cancelado la distribución de la publicación, por lo tanto ha sido bajada.",
            "admin_pending": "Tu declaración está pendiente de revisión por parte del administrador para tomar más medidas.",
            "admin_approved": "Tu solicitud para distribuir tu publicación ha sido aprobada por nuestro equipo de administración. La publicación ha sido verificada con éxito. Apreciamos tu diligencia en asegurar la precisión y el cumplimiento. La publicación procederá a todas las tiendas según lo planeado. Gracias por tu atención al detalle y adherencia a nuestros estándares.",
            "admin_rejected": "Tu solicitud para distribuir tu publicación ha sido rechazada. Después de una revisión cuidadosa, la solicitud no cumple con nuestros requisitos de aprobación. Recomendamos reevaluar el contenido y asegurar que se abordan todas las condiciones e implicaciones legales. Gracias por tu comprensión y cooperación.",
            "scanInProgress": "Escaneo en progreso, por favor, espera a que el escaneo se complete.",
            "releaseMustBeReady": "La publicación debe estar en estado Ready para realizar el pre-escaneo.",
            "errorSubmittingDeclaration": "Error ocurrido al enviar la declaración del administrador del pre-escaneo.",
        }
    }
};

export default preScanES;